import React, { useEffect, useState } from "react";
import { Table, Select, Modal, Button, Flex, Upload, message, Space, Popconfirm, Typography, Tooltip, Input, Image, Spin, Tag, Card, List } from "antd";
import { InboxOutlined, CloseOutlined, EditOutlined, UploadOutlined, DeleteOutlined, EyeOutlined, LoginOutlined, DollarCircleOutlined, ClockCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import axios from "axios";

const { Dragger } = Upload;

function UsersRewards({ isLoading }) {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [existingFiles, setExistingFiles] = useState([]);
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [CountData, setCountData] = useState(0);
  const paginationLimit = 10;

  useEffect(() => {
    fetchList();
  }, [page]);

  const columns = [
    {
      title: "#",
      dataIndex: "count",
      key: "count",
      fixed: "left",
      width: "50px",
    },
    {
      title: "Name",
      key: "fullname",
      dataIndex: "fullname",
      width: "200px",
      fixed: "left",
    },
    {
      title: "Mail",
      dataIndex: "email",
      key: "mail",
      width: "250px",
      fixed: "left",
    },
    {
      title: "User Code",
      dataIndex: "userCode",
      key: "userCode",
      width: "120px",
    },
    {
      title: "Phone number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      width: "150px",
    },
    {
      title: "Action",
      key: "action",
      dataIndex: "action",
      width: "150px",
      render: (e, rec) => (
        <Space>
          <Button
            type={rec.uploadedFiles && rec.uploadedFiles.length > 0 ? "primary" : "default"}
            icon={<UploadOutlined />}
            size={"middle"}
            onClick={() => uploadOpen(rec)}
          />
        </Space>
      ),
    },
  ].filter(Boolean);

  const uploadOpen = (rec) => {
    setSelectedUser(rec);
    setIsUploadOpen(true);
    setExistingFiles([]);
    getUploadedFiles(rec);
  };

  const fetchList = async () => {
    setLoading(true);

    try {
      const { data: usersRaw } = await axios.get(
        `${process.env.REACT_APP_ADMIN_API_URL}admin/reward-achievers`,
        {
          headers: { "x-product-type": "PIP_GRID" },
        }
      );
      console.log("~ usersRaw:", usersRaw);

      const usersWithFiles = await Promise.all(
        usersRaw?.data?.map(async (user, index) => {
          let uploadedFiles = [];

          try {
            const fileRes = await axios.get(
              `${process.env.REACT_APP_ADMIN_API_URL}admin/uploaded-files/${user._id}`,
              {
                headers: { "x-product-type": "PIP_GRID" },
              }
            );
            uploadedFiles = fileRes.data?.file ? [fileRes.data.file] : [];
          } catch (err) {
            console.warn(`Error fetching files for user ${user._id}`);
          }

          return {
            id: user?._id,
            count: index + 1,
            key: user?._id,
            fullname: user?.fullName || "-",
            phoneNumber: user?.phoneNumber || "-",
            email: user?.email || "-",
            userCode: user?.userCode || "-",
            uploadedFiles,
            referredBy: user?.referralInfo?.refferedBy?.fullName || "-",
            referralCode: user?.referralInfo?.refferalCode || "-",
          };
        })
      );

      setUserList(usersWithFiles);
      setCountData(usersRaw?.count || 0);
    } catch (error) {
      console.error("Error fetching users:", error);
      message.error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  const handleUpload = (file) => {
    setUploading(true);
    const formData = new FormData();
    formData.append("files", file);

    axios
      .post(`${process.env.REACT_APP_ADMIN_API_URL}admin/upload-reward-file/${selectedUser?.key}`, formData, {
        headers: {
          "x-product-type": "PIP_GRID",
        },
      })
      .then((res) => {
        message.success("File uploaded successfully");
        getUploadedFiles(selectedUser);
      })
      .catch((e) => message.error("File upload failed"))
      .finally(() => {
        setUploading(false);
      });
  };

  const getUploadedFiles = (rec) => {
    axios
      .get(`${process.env.REACT_APP_ADMIN_API_URL}admin/reward-file/${rec?.key}`, {
        headers: {
          "x-product-type": "PIP_GRID",
        },
      })
      .then((res) => {
        console.log(res?.data?.file, "res");
        setExistingFiles(res.data?.file ? [res.data.file] : []);
        fetchList({});
      })
      .catch((e) => message.error("Error fetching uploaded files"));
  };
  const handlePagination = (pageNum) => {
    setPage(pageNum);
    fetchList(pageNum);
  };

  return (
    <Spin spinning={loading} size="large">
      <Modal title="Upload File" open={isUploadOpen} onCancel={() => setIsUploadOpen(false)} footer={[]} width={800}>
        {existingFiles.length === 0 && (
          <Dragger
            name="file"
            multiple={false}
            customRequest={({ file, onSuccess, onError }) => {
              handleUpload(file);
              onSuccess("ok");
            }}
            showUploadList={false}
            style={{ marginBottom: 20 }}
          >
            {uploading ? (
              <div style={{ padding: "20px 0" }}>
                <Spin tip="Uploading..." />
              </div>
            ) : (
              <>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                <p className="ant-upload-hint">Support for a single upload.</p>
              </>
            )}
          </Dragger>
        )}

        <List
          header={<div>Uploaded Files</div>}
          bordered
          dataSource={existingFiles}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Button
                  type="text"
                  danger
                  loading={deletingId === item._id}
                />,
              ]}
            >
              <Typography.Text>{item.name || item.fileName || "Unnamed File"}</Typography.Text>
            </List.Item>
          )}
        />
      </Modal>

      <Typography.Title level={3} className="page-title">
        Rewards
      </Typography.Title>

      <Table
        columns={columns}
        dataSource={userList}
        scroll={{ x: 1500, y: 600 }}
        pagination={{
          current: page,
          pageSize: paginationLimit,
          total: CountData,
          onChange: handlePagination,
          showSizeChanger: false
        }}
        loading={loading}
        rowKey="_id"
      />
    </Spin >
  );
}
const mapStateToProps = ({ loading }) => {
  const { isLoading } = loading;
  return { isLoading };
};
export default connect(mapStateToProps, {})(UsersRewards);
